import colors from "vuetify/es5/util/colors";
import { ThemeOptions } from "vuetify/types/services/theme";

export const sparTheme: ThemeOptions = {
  themes: {
    light: {
      primary: "#20603D",
      secondary: "#cc0605",
      accent: colors.lime.base,
      error: colors.pink.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: colors.lightGreen.base,
    },
  },
};
